<template>
  <div class="visible lg:invisible block lg:hidden" v-if="isUserThisBroker">
    <div class="py-2 px-4 bg-gray-100">
      <select class="select-standard" v-model="route" v-on:change="pathChanged">
        <option value="broker-account">My Details</option>
        <option value="broker-password">Password</option>
        <option value="broker-site-appearance">Site Appearance</option>
        <option value="broker-integration">Integrations</option>
        <option value="broker-mail-setting">Mail Settings</option>
        <option value="broker-payment">Payment Details</option>
        <option value="broker-lead-capture">Lead Capture Form</option>
        <option value="broker-template">Templates</option>
      </select>
    </div>
  </div>
</template>

<script>
  export default {

    data() {
      return {
        route : this.$route.name
      }
    },

    methods : {
      pathChanged() {
        this.$router.push({ 
          name  : this.route,
          params: {
            brokerId : this.$route.params.brokerId
          }
        })
      }
    }
  }
</script>